import { useAppSelector } from 'src/redux/hooks';
import { GlobalState } from 'src/redux/store';

export const proposalDocumentTypesSelector = (state: GlobalState) => state.proposalDocumentTypes;

export const proposalDocumentTypesSelectorData = (state: GlobalState) =>
    proposalDocumentTypesSelector(state).data;

export const useProposalDocumentTypes = () => useAppSelector(proposalDocumentTypesSelectorData);
